<template>
    <div>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="hasInvoices"
                class="Invoices"
            >
                <PageTitle class="Invoices-title">
                    {{ $t('personal-account.invoices.title') }}
                </PageTitle>
                <div class="Invoices-globalContainer">
                    <div class="Invoices-container">
                        <div
                            v-for="(invoicesByYear, year) in arrayInvoicesByYear"
                            :key="year"
                            class="Invoices-block"
                        >
                            <div class="Invoices-blockHeader">
                                <div class="Invoices-year">
                                    {{ invoicesByYear.year }}
                                </div>
                                <!--                                <div class="Invoices-download">-->
                                <!--                                    <RoundedButton-->
                                <!--                                        :label="$t('personal-account.invoices.download')"-->
                                <!--                                        type="white"-->
                                <!--                                        @buttonClicked="download(year)"-->
                                <!--                                        class="Invoices-downloadButton"-->
                                <!--                                        size="small"-->
                                <!--                                    />-->
                                <!--                                </div>-->
                            </div>

                            <Block
                                :withoutPadding="true"
                            >
                                <List :items="invoicesByYear.invoices">
                                    <template #listItem="{item}">
                                        <InvoiceItem
                                            :invoice="item"
                                        />
                                    </template>
                                </List>
                            </Block>
                        </div>
                    </div>
                    <div class="Invoices-filter">
                        <CircleIconButton
                            class="Invoices-filterButton"
                            icon="f2m-filter"
                            data-cy="button.filter"
                            @buttonClicked="toggleFiltersModal"
                        />
                    </div>
                </div>
            </div>
        </Transition>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="hasInvoices===false"
                class="Invoices"
            >
                <div class="Invoices-empty">
                    <span class="f2m-invoice Invoices-emptyIcon" />
                    <div class="Invoices-emptyTitle">
                        {{ $t('personal-account.invoices.empty.title') }}
                    </div>
                    <div class="Invoices-emptyDescription">
                        {{ $t('personal-account.invoices.empty.description') }}
                    </div>
                </div>
            </div>
        </Transition>
        <FullScreenModal
            :showModal="showFiltersModal"
            type="custom"
            class="Invoices-filterModal"
        >
            <div class="col col-sm-12 col-md-6 offset-md-3">
                <div class="Invoices-filterModalHeader">
                    <div class="Invoices-filterModalHeaderTitle">
                        {{ $t('personal-account.invoices.filter.title') }}
                    </div>
                    <RoundedButton
                        type="white"
                        :label="$t('personal-account.invoices.filter.reset')"
                        data-cy="button.reset"
                        @buttonClicked="resetFilters"
                    />
                </div>
                <div class="Invoices-filterModalSubTitle">
                    {{ $t('personal-account.invoices.filter.byServices') }}
                </div>
                <div class="Invoices-filterModalServiceContainer">
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.all')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'all'"
                                data-cy="button.all"
                                @buttonClicked="selectedService = 'all'"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.carsharing')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'carsharing'"
                                data-cy="button.carsharing"
                                @buttonClicked="selectedService = 'carsharing'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.rent')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'rent'"
                                data-cy="button.rent"
                                @buttonClicked="selectedService = 'rent'"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.park')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'park'"
                                data-cy="button.park"
                                @buttonClicked="selectedService = 'park'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.cod')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'cod'"
                                data-cy="button.cod"
                                @buttonClicked="selectedService = 'cod'"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.refill')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'refill'"
                                data-cy="button.refill"
                                @buttonClicked="selectedService = 'refill'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.invoices.filter.other')"
                                class="Invoices-filterModalServiceButton"
                                :active="selectedService === 'other'"
                                data-cy="button.other"
                                @buttonClicked="selectedService = 'other'"
                            />
                        </div>
                    </div>
                </div>

                <div class="Invoices-filterModalSubTitle">
                    {{ $t('personal-account.invoices.filter.byDate') }}
                </div>
                <div class="Invoices-filterModalDateContainer row">
                    <div class="col col-12 col-md-6">
                        <InputDropdown
                            v-model="selectedYear"
                            :label="$t('personal-account.invoices.filter.years')"
                            :items="years"
                            class="Invoices-inputDropdown"
                            data-cy="dropdown.year"
                        />
                    </div>
                    <div class="col col-12 col-md-6">
                        <InputDropdown
                            v-model="selectedMonth"
                            :label="$t('personal-account.invoices.filter.months')"
                            :items="months"
                            class="Invoices-inputDropdown"
                            :disabled="selectedYear === '0'"
                            data-cy="dropdown.month"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="Invoices-filterModalFooter row">
                    <div class="col col-sm-12 col-md-6 offset-md-3 ">
                        <div class="row">
                            <div class="col col-4 col-md-3 offset-md-1">
                                <RoundedButton
                                    :label="$t('personal-account.invoices.filter.cancel')"
                                    class="Invoices-filterModalFooterButton"
                                    data-cy="button.cancel"
                                    @buttonClicked="toggleFiltersModal"
                                />
                            </div>
                            <div class="col col-8 col-md-7">
                                <RoundedButton
                                    :label="$t('personal-account.invoices.filter.submit', {count})"
                                    type="reversed"
                                    class="Invoices-filterModalSubmitButton Invoices-filterModalFooterButton"
                                    :loading="loading"
                                    :inactive="count === 0"
                                    data-cy="button.submit"
                                    @buttonClicked="submitFilters"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </FullScreenModal>
    </div>
</template>

<script>
import InvoiceItem from "@/components/InvoiceItem.vue";
import {Block} from "@free2move/vuejs-components";
import {
    GET_INVOICES,
    GET_RENTS,
    GET_CARSHARINGS,
    GET_PARKS,
    GET_COD_CONTRACTS,
    GET_REFILLS
} from "@/store/action-types";
import PageTitle from '@/components/PageTitle.vue';
import * as mutationTypes from "@/store/mutation-types";
import Transition from "@/components/Transition.vue"
import RoundedButton from "@/components/common/RoundedButton.vue";
import FullScreenModal from "@/components/FullScreenModal.vue";
import InputDropdown from "@/components/common/InputDropdown.vue";
import _ from "lodash";

import dayjs from "dayjs";
import CircleIconButton from "@/components/CircleIconButton.vue";
import List from "@/components/List.vue";

import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
    components: {
        CircleIconButton,
        InvoiceItem,
        PageTitle,
        Transition,
        RoundedButton,
        FullScreenModal,
        InputDropdown,
        List,
        Block,
    },
    watch: {
        selectedYear() {
            if (this.selectedYear === '0')
                this.selectedMonth = '0';
            this.countResults();
        },
        selectedMonth() {
            this.countResults();
        },
        selectedService() {
            this.countResults();
        },
        arrayInvoicesByYear() {
            this.setYears();
        }
    }
})
export default class Invoices extends Vue {
    data() {
        return {
            defaultObject: {
                rent: null,
                carsharing: null,
                refill: null,
                codContract: null,
            },
            showFiltersModal: false,
            invoices: [],
            hasInvoices: null,
            count: 0,
            selectedYear: '0',
            selectedMonth: '0',
            selectedService: 'all',
            initialValues: {
                selectedYear: '0',
                selectedMonth: '0',
                selectedService: 'all'
            },
            loading: false,
            years: [],
        }
    }

    mounted() {
        this.getInvoices();
        this.countResults();
    }

    get arrayInvoicesByYear() {
        const array = this.invoices.reduce((acc, invoice) => {
            const year = dayjs(invoice.created).format('YYYY');
            const keyYear = _.findIndex(acc, (item) => item.year === year);
            if (keyYear === -1) {
                acc.push({
                    year,
                    invoices: [invoice]
                });
            } else {
                acc[keyYear].invoices.push(invoice);
            }
            return acc.map((yearObject) => {
                return {
                    ...yearObject,
                    invoices: _.sortBy(yearObject.invoices, (invoice) => {
                        return dayjs(invoice.created).format('YYYYMMDD');
                    }).reverse()
                }
            })
        }, []);
        return _.sortBy(array, 'year').reverse();
    }
    get months() {
        return {
            '0': this.$t('personal-account.invoices.filter.all'),
            '1': this.$t('personal-account.invoices.filter.january'),
            '2': this.$t('personal-account.invoices.filter.february'),
            '3': this.$t('personal-account.invoices.filter.march'),
            '4': this.$t('personal-account.invoices.filter.april'),
            '5': this.$t('personal-account.invoices.filter.may'),
            '6': this.$t('personal-account.invoices.filter.june'),
            '7': this.$t('personal-account.invoices.filter.july'),
            '8': this.$t('personal-account.invoices.filter.august'),
            '9': this.$t('personal-account.invoices.filter.september'),
            '10': this.$t('personal-account.invoices.filter.october'),
            '11': this.$t('personal-account.invoices.filter.november'),
            '12': this.$t('personal-account.invoices.filter.december'),
        }
    }
    get conditions() {
        const gte = this.selectedYear + (this.selectedMonth !== '0' ? '-' + this.selectedMonth.padStart(2, '0') : '');
        const lt = this.selectedMonth === '0'
            ? (parseInt(this.selectedYear) + 1).toString()
            : this.selectedYear + '-' + (parseInt(this.selectedMonth) + 1).toString().padStart(2, '0');
        return {
            ...(!['all', 'other'].includes(this.selectedService) && {modelHolder: {$regex: "^" + this.selectedService}}),
            ...(this.selectedService === 'other' && {modelHolder: {$exists: false}}),
            ...(this.selectedYear !== '0' && {"$and": [{"created": {"$gte": gte}},{"created": {"$lt": lt}}]}),
        }
    }
    get rentIds() {
        return this.getServiceIds('rent')
    }
    get carsharingIds() {
        return this.getServiceIds('carsharing')
    }
    get parkIds() {
        return this.getServiceIds('park')
    }
    get codContractIds() {
        return this.getServiceIds('cod-contract-v-2')
    }
    get refillIds() {
        return this.getServiceIds('refill');
    }

    toggleFiltersModal() {
        this.showFiltersModal = !this.showFiltersModal;
    }
    resetFilters() {
        this.selectedYear = this.initialValues.selectedYear;
        this.selectedMonth = this.initialValues.selectedMonth;
        this.selectedService = this.initialValues.selectedService;
    }
    getServiceIds(service){
        return this.invoices.reduce((acc, invoice) => {
            if(!invoice.modelHolder) return acc;

            const modelHolder = invoice.modelHolder.split('+');
            if (modelHolder[0] === service) {
                acc.push(modelHolder[1]);
            }
            return acc;
        }, []);
    }
    getInvoices(){
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_INVOICES, {
            callback: function (data) {
                this.invoices = data.map((invoice) => {
                    return {...this.defaultObject, ...invoice}
                });

                this.hasInvoices = this.invoices.length > 0;
                if(this.rentIds.length > 0) {
                    this.getServiceItemsFromIds({
                        action: GET_RENTS,
                        servicePrefix: 'rent',
                        serviceKey: 'rent',
                        ids: this.rentIds,
                        select: "duration car from.date to.date"
                    });
                }
                if (this.carsharingIds.length > 0) {
                    this.getServiceItemsFromIds({
                        action: GET_CARSHARINGS,
                        servicePrefix: 'carsharing',
                        serviceKey: 'carsharing',
                        ids: this.carsharingIds,
                        select: "car from.date to.date"
                    });
                }
                if (this.refillIds.length > 0) {
                    this.getServiceItemsFromIds({
                        action: GET_REFILLS,
                        servicePrefix: 'refill',
                        serviceKey: 'refill',
                        ids: this.refillIds,
                        select: "date"
                    });
                }
                if (this.codContractIds.length > 0) {
                    this.getServiceItemsFromIds({
                        action: GET_COD_CONTRACTS,
                        servicePrefix: 'cod-contract-v-2',
                        serviceKey: 'codContract',
                        ids: this.codContractIds,
                        select: "offer created"
                    });
                }
                if (this.parkIds.length > 0) {
                    this.getServiceItemsFromIds({
                        action: GET_PARKS,
                        servicePrefix: 'park',
                        serviceKey: 'park',
                        ids: this.parkIds,
                        select: "agency from.date to.date"
                    });
                }
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                window.scrollTo(0, 0);
            }.bind(this),
            data: {
                conditions: this.conditions
            }
        });
    }
    getServiceItemsFromIds({action, servicePrefix, serviceKey, ids, select}) {
        this.$store.dispatch(action, {
            callback: function (data) {
                data.forEach((item) => {
                    _.keys(_.pickBy(this.invoices, (invoice) => {
                        const modelHolder = invoice.modelHolder.split('+');
                        return modelHolder[0] === servicePrefix && modelHolder[1] === item._id;
                    })).forEach((key) => {
                        this.invoices[key][serviceKey] = item;
                    });
                });
            }.bind(this),
            data: {
                conditions: {
                    _id: {$in: ids}
                },
                select
            }
        });
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
    }
    submitFilters() {
        this.toggleFiltersModal();
        this.getInvoices();
    }
    countResults() {
        this.loading = true;
        this.$store.dispatch(GET_INVOICES, {
            callback: function (data) {
                this.count = data.count;
                this.loading = false;
            }.bind(this),
            data: {
                count: true,
                conditions: this.conditions
            }
        });
    }
    setYears() {
        if(_.isEmpty(this.years)) {
            this.years = this.arrayInvoicesByYear.reduce((acc, yearObject) => {
                acc[yearObject.year] = yearObject.year;
                return acc;
            },
            {'0': this.$t('personal-account.invoices.filter.all')}
            );
        }
    }
}
</script>

<style lang="scss" scoped>
.Invoices {
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }


    &-container {
        flex-grow:1;
        margin-bottom: 28px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

    }

    &-globalContainer {
        display: flex;
        gap: 38px;

        @media (max-width: $f2m-desktop-breakpoint) {
            gap: 0;
        }
    }

    &-year {
        font-size: 18px;
        line-height: 22px;
        color: white;
        font-weight: bold;
        margin-left: 12px;
    }

    &-blockHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
    }

    &-block {
        margin-bottom: 28px;
    }

    &-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 100%;
        color: #fff;
        margin-top: 50px;
        max-width: 495px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

        &Icon {
            font-size: 123px;
            display: block;
            margin-bottom: 42px;
        }

        &Title {
            font-size: 30px;
            line-height: 36px;
            margin-bottom: 24px;
        }

        &Description {
            font-weight: 400;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.3px;
            max-width: 320px;
        }
    }

    &-filter {
        margin: 38px 0 0 0;

        @media (max-width: $f2m-desktop-breakpoint) {
            margin: 0;
        }
    }

    &-filterButton {
        @media (max-width: $f2m-desktop-breakpoint) {
            position: fixed;
            right: 20px;
            bottom: 40px;
            z-index: 1;
        }
    }

    &-title {
        margin-bottom: 36px;
    }


    &-filterModalHeader{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 185px;
        margin-bottom: 48px;

        @media (max-width: $f2m-desktop-breakpoint) {
            margin-top: 60px;
        }
    }

    &-filterModalHeaderTitle{
        font-size: 30px;
        line-height: 36px;
        font-weight: bold;
        letter-spacing: 0.818182px;
        color: $color-white;
    }

    &-filterModalFooter {
        background-color: $color-white;
        padding: 15px;
    }

    &-filterModalSubTitle{
        font-size: 22px;
        line-height: 26px;
        color: $color-white;
        margin-bottom: 15px;
    }

    &-filterModalServiceContainer{
        .row{
            margin-bottom: 20px;
            &:last-child{
                margin-bottom: 40px;
            }
        }
    }

    &-filterModalServiceButton {
        width: 100%;
    }

    &-filterModalDateContainer {
        .col {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        margin-bottom: 20px;
    }
    &-filterModalFooterButton {
        width: 100%;
    }
}
</style>
